import { HqAndOfficeIdRouteParams } from "components/SelectHqOfficeCombobox/helper";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getHqById, getOfficeById } from "api/services/configService";

export const useOfficeAndHq = () => {
  const { hqId, officeId } = useParams<HqAndOfficeIdRouteParams>();

  const { data: hq } = useQuery(
    ["getHqById", hqId],
    () => getHqById(hqId ?? "0000"),
    {
      enabled: Boolean(hqId)
    }
  );

  const { data: office } = useQuery(
    ["getOfficeById", officeId],
    () => getOfficeById(officeId ?? "0000"),
    {
      enabled: Boolean(officeId) && officeId !== ":officeId"
    }
  );

  return {
    hq,
    office
  };
};
